import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { VetValueFees } from '../../../../../components/FlowOfFunds/VetValueFees/VetValueFees';
import { AgreeToVetValueFees } from '../../../../../slices/marketplace/flow-of-funds/thunks/agree-to-vetvalue-fees.thunk';
import { useFlowOfFunds } from '../useFlowOfFunds';

export interface VetValueFeesSubTabProps {
    engagementId: number;
}

/** VetValue Fees — the VV Connect fee ledger and the seller ↔ VetValue sign-off. */
export const VetValueFeesSubTab = (props: VetValueFeesSubTabProps) => {
    const dispatch = useDispatch<any>();
    const { flowOfFunds, isLoading } = useFlowOfFunds(props.engagementId);
    const [isSaving, setIsSaving] = useState(false);

    const onAgree = async () => {
        setIsSaving(true);
        try {
            await dispatch(
                AgreeToVetValueFees({ engagementId: props.engagementId, agreed: true })
            ).unwrap();
        } finally {
            setIsSaving(false);
        }
    };

    if (isLoading) {
        return <div className="mt-4 text-muted">Loading…</div>;
    }
    if (!flowOfFunds?.vetValueFees) {
        return (
            <div className="mt-4 text-muted">
                No fee schedule has been recorded for this engagement yet.
            </div>
        );
    }

    return (
        <div className="mt-4">
            <VetValueFees
                fees={flowOfFunds.vetValueFees}
                levelOfService={flowOfFunds.consideration.feeInputs.levelOfService}
                onAgree={onAgree}
                isSaving={isSaving}
                closing={flowOfFunds.closing}
                sfasParams={flowOfFunds.consideration.feeInputs.sfasParams}
            />
        </div>
    );
};

export default VetValueFeesSubTab;
